import { DialogService, GridAction } from '@eforall/dashboard';
import { DialogMode, EngagementContactInteraction } from '@interfaces';
import { EngagementInteractionFormDialog, EngagementInteractionFormDialogData } from '../../../../../../ui/widget';
import { EngagementViewerDialogService } from '../../engagement-viewer.service';

export function getActions(pageService: EngagementViewerDialogService, dialog: DialogService) {

	const actions: GridAction<EngagementContactInteraction & { updatedUTC: number }>[] = [
		{
			iconClass: 'fa-regular fa-pen-to-square',
			label: 'Edit interaction',
			isEnabled: rows => !!rows.length,
			execute: async (rows) => {
				const dialogData: EngagementInteractionFormDialogData = {
					mode: DialogMode.EDIT,
					engagementId: rows[0]!.engagementId, // checked in isEnabled rows[0] is guaranteed to exist
					engagementContactId: rows[0]!.engagementContactId
				}
				await dialog.showCustom(EngagementInteractionFormDialog, { data: dialogData }, 550, 550);
				await pageService.getEngagementDetails(dialogData.engagementId);
			}
		},
		{
			iconClass: 'fa-regular fa-trash-can',
			label: 'Remove interaction',
			isEnabled: rows => !!rows.length,
			execute: async (rows) => {
				const yes = await dialog.confirm('Are you sure you want to remove the interaction?', 'Yes', 'No', [], 400, 200);
				if (yes) {
					await pageService.deleteEngagementInteraction(rows[0]!.engagementId, rows[0]!.engagementContactId); // checked in isEnabled rows[0] is guaranteed to exist
					await pageService.getEngagementDetails(rows[0]!.engagementId);
				}
			}
		},
	];

	return actions;
}